(function () {
    'use strict';

    angular
        .module('advancedapp')
        .factory('search_service', search_service);

    search_service.$inject = ['$http'];

    //var searchUrl = '/sitewidesearch/search'

    function search_service($http) {
        var service = {
            search: search
        };

        return service;

        function search(searchUrl, searchModel) {
            // ensure the ContentDeliveryApi does not reroute the request
            // by adding the custom 'Routed-By-ContentApi' header and 
            // set its value to false
            return $http({
                method: 'POST',
                url: searchUrl,
                data: searchModel,
                headers: {
                    'Content-Type': 'application/json',
                    'Routed-By-ContentApi': 'false'
                }
            })//.post(searchUrl, searchModel)
                .then(function (response) {
                    return response.data;
                },
                function (error) {
                    //console.log(error);
                }
            );
        }
    }
})();